export default "__VITE_ASSET__CwWHohDj__"